(function () {

    'use strict';

    angular.module('iplusjs.validator.kfz.vbnummer', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.vertrag',
        'iplusjs.utils.identityType',
        'iplusjs.fieldset',
        'iplusjs.utils.formField'
    ])
    .directive('iplusjsKfzVbnummerValidator', kfzVbnummerValidator);

    kfzVbnummerValidator.$inject = [
        '$q',
        '$log',
        'lodash',
        'MiscUtilsService',
        'VertragUtilsService',
        'IdentityTypeUtilsService',
        'FormFieldUtilsService'
    ];
    function kfzVbnummerValidator($q, $log, _, MiscUtilsService, VertragUtilsService, IdentityTypeUtilsService, FormFieldUtilsService) {
        return {
            require: ['ngModel', '^?iplusjsFieldset'],
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1];

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                return;
            }
            $ngModel.$validators.vbnummerFormat = function (value) {
                var validationValue;

                validationValue = value;

                if (IdentityTypeUtilsService.isIdentityType(validationValue)) {
                    validationValue = IdentityTypeUtilsService.getId(validationValue);
                }

                if (MiscUtilsService.isEmpty(validationValue)) {
                    return true;
                }

                $log.debug('kfzVbnummerValidator $validators.vbnummerFormat', value);

                return IdentityTypeUtilsService.isValid(validationValue, 'vbnummer');
            };
            $ngModel.$asyncValidators.vbnummerExists = function (value) {
                $log.debug('kfzVbnummerValidator $asyncValidators.vbnummerExists', value);

                if (MiscUtilsService.isEmpty(value)) {
                    return $q.resolve();
                }

                return VertragUtilsService.existsVbnummer(IdentityTypeUtilsService.toId(value)).then(function () {
                    FormFieldUtilsService.renderViewValue($ngModel);

                    return true;
                }).catch(function () {
                    return $q.reject();
                });
            };
        }
    }
})();
